//
//
//

import AutomationSaved from "../automation-saved";
import Amplitude from "../../../../../../../shared/utils/amplitude";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ApplicationLevelAutomations",
  title() {
    return this.$t("sidebar.sections.automation");
  },
  components: {
    AutomationSaved
  },
  beforeMount() {
    Amplitude.logEvent("Automations - application level visited");
  }
});